import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { blockApi, memberSummaryApi } from '@formosa/shared/api/im';
import '../../styles/chat.css';

export default function BlockedUsersPage() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [summaries, setSummaries] = useState({});

  const load = useCallback(() => {
    setError('');
    blockApi
      .list()
      .then(async (data) => {
        const list = Array.isArray(data) ? data : data?.data || [];
        setItems(list);
        const ids = list.map((b) => b.memberId);
        if (!ids.length) {
          setSummaries({});
          return;
        }
        try {
          const sum = await memberSummaryApi.batch(ids);
          const map = {};
          (sum || []).forEach((s) => {
            if (s?.memberId != null) map[s.memberId] = s;
          });
          setSummaries(map);
        } catch {
          setSummaries({});
        }
      })
      .catch((e) => setError(e?.message || '載入失敗'));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const unblock = async (memberId) => {
    try {
      await blockApi.unblock(memberId);
      load();
    } catch (e) {
      setError(e?.message || '解除失敗');
    }
  };

  return (
    <div className="chat-social-page">
      <header className="chat-social-page__header">
        <Link to="/chat/contacts" className="chat-link-btn">
          ← 聯絡人
        </Link>
        <h1>封鎖名單</h1>
      </header>
      {error ? <p className="chat-social-page__error">{error}</p> : null}
      <ul className="chat-social-page__list">
        {items.map((b) => {
          const s = summaries[b.memberId];
          const name = s?.displayName || s?.username || `會員 ${b.memberId}`;
          return (
            <li key={b.memberId}>
              <div className="chat-social-page__row">
                <span className="chat-social-page__name">{name}</span>
              </div>
              <button type="button" className="chat-link-btn" onClick={() => unblock(b.memberId)}>
                解除封鎖
              </button>
            </li>
          );
        })}
      </ul>
      {!items.length ? <p className="chat-social-page__empty">沒有封鎖</p> : null}
    </div>
  );
}
